export default {
  fromValue (val) {
    switch (val) {
      case 'water':
        return 'Água'
      case 'food':
        return 'Alimentação'
      case 'rent':
        return 'Aluguel'
      case 'receivables':
        return 'Antecipação de recebíveis'
      case 'fuel':
        return 'Combustível'
      case 'loan':
        return 'Empréstimo'
      case 'energy':
        return 'Energia'
      case 'tax':
        return 'Imposto'
      case 'internet':
        return 'Internet'
      case 'legal':
        return 'Jurídico'
      case 'interest':
        return 'Juros'
      case 'cleaning':
        return 'Limpeza'
      case 'maintenance':
        return 'Manutenção'
      case 'other':
        return 'Outro'
      case 'salary':
        return 'Salário'
      case 'bank_fee':
        return 'Tarifa Bancária'
      case 'administration_fee':
        return 'Taxa de Administração'
      case 'phone':
        return 'Telefone'
      default:
        return val
    }
  }
}
